export default {
    state: {
        name: 'information'
    },
}
